import styled from "styled-components";

export const StyledFormalCompetenceList = styled.ul`
  list-style: disc;
  margin: 10px;
  padding-left: 25px;
`;
